/* tslint:disable */
/* eslint-disable */
/**
 * Wolf Security Portal Customer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0 (2.0)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PartnerConsent,
  PartnerConsentError,
  PartnerConsentRequest,
  PatchedPartnerConsentRequest,
} from '../models';
import {
    PartnerConsentFromJSON,
    PartnerConsentToJSON,
    PartnerConsentErrorFromJSON,
    PartnerConsentErrorToJSON,
    PartnerConsentRequestFromJSON,
    PartnerConsentRequestToJSON,
    PatchedPartnerConsentRequestFromJSON,
    PatchedPartnerConsentRequestToJSON,
} from '../models';

export interface ConsentRequestPartialUpdateRequest {
    id: string;
    patchedPartnerConsentRequest?: PatchedPartnerConsentRequest;
}

export interface ConsentRequestRetrieveRequest {
    id: string;
}

export interface ConsentRequestUpdateRequest {
    id: string;
    partnerConsentRequest: PartnerConsentRequest;
}

/**
 * 
 */
export class ConsentRequestApi extends runtime.BaseAPI {

    /**
     */
    async consentRequestListRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PartnerConsent>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/consent-request/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PartnerConsentFromJSON));
    }

    /**
     */
    async consentRequestList(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PartnerConsent>> {
        const response = await this.consentRequestListRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async consentRequestPartialUpdateRaw(requestParameters: ConsentRequestPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PartnerConsent>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling consentRequestPartialUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/consent-request/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedPartnerConsentRequestToJSON(requestParameters.patchedPartnerConsentRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartnerConsentFromJSON(jsonValue));
    }

    /**
     */
    async consentRequestPartialUpdate(requestParameters: ConsentRequestPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PartnerConsent> {
        const response = await this.consentRequestPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async consentRequestRetrieveRaw(requestParameters: ConsentRequestRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PartnerConsent>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling consentRequestRetrieve.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/consent-request/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartnerConsentFromJSON(jsonValue));
    }

    /**
     */
    async consentRequestRetrieve(requestParameters: ConsentRequestRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PartnerConsent> {
        const response = await this.consentRequestRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async consentRequestUpdateRaw(requestParameters: ConsentRequestUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PartnerConsent>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling consentRequestUpdate.');
        }

        if (requestParameters.partnerConsentRequest === null || requestParameters.partnerConsentRequest === undefined) {
            throw new runtime.RequiredError('partnerConsentRequest','Required parameter requestParameters.partnerConsentRequest was null or undefined when calling consentRequestUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/consent-request/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PartnerConsentRequestToJSON(requestParameters.partnerConsentRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartnerConsentFromJSON(jsonValue));
    }

    /**
     */
    async consentRequestUpdate(requestParameters: ConsentRequestUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PartnerConsent> {
        const response = await this.consentRequestUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
